export const LINK_PREVIEW_SIZE = { width: 676, height: 380 };
